import type { MouseEvent } from 'react';
import { forwardRef } from 'react';

import { cn } from 'helpers/classnames';

export type HeaderIconLinkProps = {
  children: React.ReactNode;
  className?: string;
  href: string;
  label: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  text?: string;
} & { 'aria-expanded'?: boolean };

const linkClasses = 'relative flex items-center gap-x-1 py-1 px-2 rounded-sm transition-colors duration-300 hover:bg-gray-100';
const activeLinkClasses = 'bg-gray-100';
const textClasses = 'pointer-events-none select-none pr-2 body-s-medium';

const HeaderIconLink = forwardRef<HTMLAnchorElement, HeaderIconLinkProps>((props, ref) => {
  const { children, className, 'aria-expanded': isExpanded, label, text, ...forwardProps } = props;

  return (
    <a className={cn(linkClasses, { [activeLinkClasses]: isExpanded }, className)} ref={ref} aria-disabled aria-label={label} {...forwardProps}>
      {children}
      {text && <span className={textClasses}>{text}</span>}
    </a>
  );
});

export default HeaderIconLink;
